import React from 'react';
import { motion } from 'framer-motion';

const About: React.FC = () => {
  return (
    <div className="pt-40 pb-20 bg-black min-h-screen px-6 lg:px-12 flex flex-col items-center justify-center">
      <div className="max-w-3xl text-center">
         <motion.span 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-gold-500 font-mono text-xs tracking-widest mb-8 block"
         >
            NOTRE PHILOSOPHIE
         </motion.span>
         <motion.h1 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            className="font-serif text-4xl md:text-7xl text-white mb-16"
         >
            L'Excellence du Service Limousine
         </motion.h1>
         
         <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 1 }}
            className="text-xl md:text-2xl text-slate-300 font-light leading-relaxed mb-12"
         >
            "Votre temps est précieux, votre confort est notre priorité."
         </motion.p>

         <motion.div 
            initial={{ width: 0 }}
            animate={{ width: 96 }}
            transition={{ delay: 0.6, duration: 1 }}
            className="h-px bg-white/20 mx-auto mb-12"
         ></motion.div>

         <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.8 }}
            className="text-left text-slate-400 font-light space-y-8 text-base md:text-lg"
         >
            <p>
            Bienvenue chez LimoHass, votre partenaire de référence à Lausanne, Capitale Olympique. Nous sommes spécialisés dans la location de minivans Mercedes avec chauffeur, offrant une solution de mobilité de qualité supérieure pour tous vos déplacements à travers la Suisse.
            </p>
            <p>
            Qu'il s'agisse de transferts aéroportuaires, d'événements prestigieux, de mariages ou de soirées privées, notre équipe de chauffeurs expérimentés s'engage à vous offrir une expérience d'exception. Notre philosophie repose sur un service personnalisé et une attention méticuleuse portée à chaque détail.
            </p>
            <p>
            Ville dynamique et culturelle, Lausanne mérite une exploration à la hauteur de son standing. Grâce à notre service de transport VIP, profitez pleinement des richesses de la Capitale Olympique — de ses musées emblématiques à ses événements internationaux — dans un confort absolu.
            </p>
               <p>
               Contactez-nous dès aujourd’hui pour planifier votre prochain trajet. Que ce soit pour un déplacement professionnel ou privé, l'équipe de LimoHass est impatiente de vous accueillir à bord et de vous offrir une expérience de voyage inoubliable à Lausanne et dans toute la Suisse.
               </p>

         </motion.div>
      </div>
    </div>
  );
};

export default About;